// router
import { NavLinkProps } from 'react-router-dom';

// mui
import {
	Box,
	Tabs as MuiTabs,
	TabsProps as MuiTabsProps,
	Tab,
	TabProps as MuiTabProps,
	BadgeProps,
	Badge,
	BoxProps,
	SxProps,
} from '@mui/material';

// props
export type TabProps = MuiTabProps &
	Partial<NavLinkProps> & {
		BadgeProps?: BadgeProps;
		[key: `data-${string}`]: string | undefined;
	};

export interface TabsProps extends MuiTabsProps {
	BoxProps?: BoxProps;
	hasBorder?: boolean;
	tabs: TabProps[];
}

export const Tabs = ({
	BoxProps = {},
	hasBorder = true,
	scrollButtons = false,
	tabs,
	variant = 'scrollable',
	...props
}: TabsProps) => {
	return (
		<Box
			{...BoxProps}
			sx={(theme) => {
				let sx: SxProps = {};

				if (BoxProps?.sx) {
					sx = {
						...sx,
						...(BoxProps.sx as object),
					};
				}

				if (hasBorder) {
					sx = {
						...sx,
						borderBottomColor: theme.palette.divider,
						borderBottomStyle: 'solid',
						borderBottomWidth: 1,
					};
				}

				return sx;
			}}>
			<MuiTabs
				scrollButtons={scrollButtons}
				TabIndicatorProps={{
					sx: {
						backgroundColor: 'brand.blue.400',
					},
				}}
				textColor="secondary"
				variant={variant}
				{...props}>
				{tabs.map((tab, i) => {
					const { BadgeProps, label, value, ...tabProps } = tab;

					let labelFormatted = label;

					if (BadgeProps) {
						labelFormatted = <Badge {...BadgeProps}>{label}</Badge>;
					}

					return (
						<Tab label={labelFormatted} {...tabProps} key={`tab-${i}-${value}`} value={value} />
					);
				})}
			</MuiTabs>
		</Box>
	);
};
